import { render, staticRenderFns } from "./list-rwo.vue?vue&type=template&id=4521fb38&"
import script from "./list-rwo.vue?vue&type=script&lang=js&"
export * from "./list-rwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports